// extracted by mini-css-extract-plugin
export default {"buttons":"PriceList_buttons__fhBiv"};